<template>
  <hm-content title="">
    <div class="mb10 flex flex-end">
      <el-input
        clearable
        v-model.trim="searchCondition.goodsName"
        placeholder="请输入商品名称"
        style="width:300px"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="">
      <el-table
        stripe
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsName"
          label="商品名称"
          width="500"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="planName"
          label="权重"
        ></el-table-column> -->
        <!-- <el-table-column
          header-align="left"
          align="left"
          prop="categoryName"
          label="设置必推"
          width="330"
        >
          <template slot-scope="scope">
            <div class="pointer flex item-center">
              <i
                style="font-size: 16px; margin-right: 5px"
                class="el-icon-setting blue"
              ></i>
              <el-tag type="success" effect="plain" size="mini"> 必推 </el-tag>
              <span>2020-12-08 12:00至2020-12-12 12:00失效</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="品类"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tagName"
          label="标签名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="品牌"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalVisitNum"
          label="价格"
        >
          <template slot-scope="scope">
            ￥{{ scope.row.prices || "0.00" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="上架时间"
          prop="upTime"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="openRults(scope.row)"
              >反馈</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="设置必推"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="设置必推" prop="sxx">
          <el-radio-group v-model="ruleForm.sxx">
            <el-radio label="yes">设为必推</el-radio>
            <el-radio label="no">不设置</el-radio>
          </el-radio-group>
          <div>
            必推时间
            <el-date-picker
              clearable
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.createTimeArry"
              type="datetimerange"
              align="right"
              start-placeholder="请选择开始时间"
              end-placeholder="请选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submit('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisible = false" size="small" type="info"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleNotTag" style="border:none;">
      <div class="contain flex">
        <div class="flex result flex-center item-center">
          <span class="icon el-icon-message"></span>
        </div>
        <div class="tips">标签值反馈</div>
        <div class="operation">
          <el-button type="primary" @click="notTag">该商品不是此标签</el-button>
          <el-button
            type="info"
            plain
            class="ml10"
            @click="dialogVisibleNotTag = false"
            >暂不处理</el-button
          >
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { toPrice } from "@/utils/utils";
export default {
  components: {},
  data() {
    const pregnantendValueFunc = (rule, val, callback) => {
      if (val === "yes") {
        if (!this.isArray(this.ruleForm.createTimeArry)) {
          return callback(new Error("请选择时间"));
        }
      }
      callback();
    };
    return {
      row: {},
      dialogVisibleNotTag: false,
      dialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      ruleForm: {
        sxx: "yes"
      },
      rules: {
        sxx: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          },
          {
            required: true,
            validator: pregnantendValueFunc
          }
        ]
      },
      dialogVisibles: false,
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {},
      recommendId: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.recommendId) {
      this.recommendId = this.$route.query.recommendId;
    }
    this.queryList();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async notTag() {
      await this.$store.dispatch("queryTagDelete", {
        source: "slz_goods",
        ids: this.row.id,
        state: "0"
      });
      this.$message({
        message: "操作成功",
        type: "warning"
      });
      this.dialogVisibleNotTag = false;
      this.queryList();
    },
    openRults(row) {
      this.row = row;
      this.dialogVisibleNotTag = true;
    },
    async submit(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        // const params = JSON.parse(JSON.stringify(this.ruleForm));
        // this.$store.dispatch("editMemberGroupConfig", params).then(res => {
        //   if (res.code === "0") {
        //     this.$message({
        //       message: "操作成功",
        //       type: "success"
        //     });
        //     this.querySysConfig();
        //   }
        // });
      } else {
        return false;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        recommendId: this.recommendId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryPhysiologicalAxisGoodsList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        records.forEach(v => {
          v.prices = v.price ? toPrice(v.price.toFixed(2)) : 0;
        });
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
